// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"AdminAICharts_backdrop___3aVn"};